import styled from "styled-components";

export const FooterContainer = styled.footer`
  display: flex;
  justify-content: center;
  background: rgba(107, 191, 191, 0.5);
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  margin-top: 2rem;
  width: 100%;
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 0.875rem;
  padding: 1.5rem 0;
  gap: 1.5rem;

  ul {
    display: flex;
    align-items: center;
    list-style: none;
    gap: 4rem;

    li {
      font-weight: 500;
      line-height: 93%;
      color: #460259;
    }
  }

  p {
    color: #434343;
  }

  @media (max-width: 768px) {
    ul {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }
  }
`;
